import { Table } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  () => ({
    root: {
      // [theme.breakpoints.up("md")]: {
      //   "&& table": {
      //     tableLayout: "fixed"
      //   }
      // },
      "& table": {
        tableLayout: "auto"
      },
      overflowX: "auto",
      width: "100%"
      // border: `1px solid ${theme.palette.grey["300"]}`,
      // borderRadius: "6px"
    }
  }),
  {
    name: "ResponsiveTable"
  }
);

interface ResponsiveTableProps {
  children: React.ReactNode | React.ReactNodeArray;
  className?: string;
  wrapperClass?: string;
  key?: string;
  style?: React.CSSProperties;
}

const ResponsiveTable: React.FC<ResponsiveTableProps> = props => {
  const { children, className, style, wrapperClass } = props;

  const classes = useStyles(props);

  return (
    <div className={classNames(classes.root, wrapperClass)} style={style}>
      <Table className={className}>{children}</Table>
    </div>
  );
};

ResponsiveTable.displayName = "ResponsiveTable";
export default ResponsiveTable;
